import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function AppliancesTechnology() {
  const { t } = useTranslation();
  const [carouselIndex, setCarouselIndex] = useState<{ [key: number]: number }>({});
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  const appliances = [
    {
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/5e62bfd0046a5554e531d4acf6b2f7c0.jpeg',
      captionKey: 'appliance_1_caption',
      descKey: 'appliance_1_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/212046f7724a777885b592b6ab6a3394.jpeg',
      captionKey: 'appliance_2_caption',
      descKey: 'appliance_2_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/41348274bfdb53d6b67ed1904c7e3d7f.jpeg',
      captionKey: 'appliance_3_caption',
      descKey: 'appliance_3_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/42d0c3a201ee77c435ef3d136f6fb176.jpeg',
      captionKey: 'appliance_4_caption',
      descKey: 'appliance_4_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/4513e6ed9a31616b05065f00a3379b99.jpeg',
      captionKey: 'appliance_12_caption',
      descKey: 'appliance_12_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/53c032394c76a1d22487f4dfbd07416c.jpeg',
      captionKey: 'appliance_5_caption',
      descKey: 'appliance_5_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/7d14ddc7a80c703845640ff150134156.png',
      captionKey: 'appliance_7_caption',
      descKey: 'appliance_7_desc'
    },
    // Second Kitchen
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/cb899c7e524d4d8902940696ac2152a4.png',
      captionKey: 'appliance_8_caption',
      descKey: 'appliance_8_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/8982e8e9c38e32d429b878ef1c2e31b9.jpeg',
      captionKey: 'appliance_9_caption',
      descKey: 'appliance_9_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/5aa9876732bf4e5a0b4a08a3ca65623b.jpeg',
      captionKey: 'appliance_10_caption',
      descKey: 'appliance_10_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/3848776dc6b6e932948c347224cc511f.jpeg',
      captionKey: 'appliance_11_caption',
      descKey: 'appliance_11_desc'
    },
    // Laundry Area
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/b7a732bc83333afbfb30e6104b4fa5b8.jpeg',
      captionKey: 'appliance_13_caption',
      descKey: 'appliance_13_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/7fa4a0f9924f1f6e6e28c10afea3d857.jpeg',
      captionKey: 'appliance_14_caption',
      descKey: 'appliance_14_desc'
    },
    // Climate & Heating
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/7865b50514de8a7ecdd335f359c50953.jpeg',
      captionKey: 'appliance_15_caption',
      descKey: 'appliance_15_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/9e7f6962d4243270efaa24dcf5650f43.jpeg',
      captionKey: 'appliance_16_caption',
      descKey: 'appliance_16_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/1b9da386b13dcaaa6520104577d7c71f.jpeg',
      captionKey: 'appliance_17_caption',
      descKey: 'appliance_17_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/daeaaf3c0967ae051437896aa4cca9b8.jpeg',
      captionKey: 'appliance_18_caption',
      descKey: 'appliance_18_desc'
    },
    // Entertainment
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/bed1e1d3a6f123be88c91796c2af20ee.jpeg',
      captionKey: 'appliance_19_caption',
      descKey: 'appliance_19_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/55989dd3f8ee2878e592c7556796b934.jpeg',
      captionKey: 'appliance_20_caption',
      descKey: 'appliance_20_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/6a33a318814dd3a12c954ebf15520820.jpeg',
      captionKey: 'appliance_21_caption',
      descKey: 'appliance_21_desc'
    },
    // Energy & Technical Systems
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/8fe583cbcd933391221c95ddb91a471d.jpeg',
      captionKey: 'appliance_22_caption',
      descKey: 'appliance_22_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/645492cfa5bfdf29a0c7342519857ae8.jpeg',
      captionKey: 'appliance_23_caption',
      descKey: 'appliance_23_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/67857d2af4f847fa854873f1d0487b8e.jpeg',
      captionKey: 'appliance_24_caption',
      descKey: 'appliance_24_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/88d03164f3f4dff57624de75bdaf1d96.jpeg',
      captionKey: 'appliance_25_caption',
      descKey: 'appliance_25_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/6a0d7c7fd0b4c5e61bf937b6968ad7d6.jpeg',
      captionKey: 'appliance_26_caption',
      descKey: 'appliance_26_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/381cd6e1c39a94ac7d677f60a7a7195f.jpeg',
      captionKey: 'appliance_27_caption',
      descKey: 'appliance_27_desc'
    },
    { 
      image: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/8076de2ec3e130acd9e6dc7a646b9215.jpeg',
      captionKey: 'appliance_28_caption',
      descKey: 'appliance_28_desc'
    }
  ];

  const handlePrevImage = (applianceIndex: number, totalImages: number) => {
    setCarouselIndex(prev => ({
      ...prev,
      [applianceIndex]: ((prev[applianceIndex] || 0) - 1 + totalImages) % totalImages
    }));
  };

  const handleNextImage = (applianceIndex: number, totalImages: number) => {
    setCarouselIndex(prev => ({
      ...prev,
      [applianceIndex]: ((prev[applianceIndex] || 0) + 1) % totalImages
    }));
  };

  const handlePrevious = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (selectedImage !== null) {
      setSelectedImage((prev) => (prev! - 1 + appliances.length) % appliances.length);
    }
  };

  const handleNext = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (selectedImage !== null) {
      setSelectedImage((prev) => (prev! + 1) % appliances.length);
    }
  };

  const handleClose = (e?: React.MouseEvent) => {
    if (e) {
      e.stopPropagation();
    }
    setSelectedImage(null);
  };

  return (
    <section className="py-24 px-4 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-center mb-8 text-gray-900">
          {t('appliances_tech_title')}
        </h2>

        <p className="text-base md:text-lg text-gray-700 text-center max-w-4xl mx-auto mb-16 leading-relaxed">
          {t('appliances_tech_intro')}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {appliances.map((appliance, index) => {
            return (
              <div key={index} className="group">
                <div 
                  onClick={() => setSelectedImage(index)}
                  className="relative overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 mb-4 cursor-pointer"
                >
                  <div className="w-full h-64">
                    <img
                      src={appliance.image}
                      alt={t(appliance.captionKey)}
                      className={`w-full h-full object-contain bg-gray-50 ${index === 0 ? '-rotate-90' : ''} ${index === 8 ? 'rotate-90' : ''}`}
                    />
                  </div>
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center">
                    <i className="ri-zoom-in-line text-white text-4xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                  </div>
                </div>
                <h3 className="font-semibold text-gray-900 text-base md:text-lg mb-2">
                  {t(appliance.captionKey)}
                </h3>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  {t(appliance.descKey)}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      {selectedImage !== null && (
        <div
          onClick={handleClose}
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 cursor-pointer"
        >
          <button
            onClick={handleClose}
            className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer z-10"
            aria-label="Close"
          >
            <i className="ri-close-line text-white text-3xl"></i>
          </button>

          <button
            onClick={handlePrevious}
            className="absolute left-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer z-10"
            aria-label="Previous image"
          >
            <i className="ri-arrow-left-s-line text-white text-3xl"></i>
          </button>

          <button
            onClick={handleNext}
            className="absolute right-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer z-10"
            aria-label="Next image"
          >
            <i className="ri-arrow-right-s-line text-white text-3xl"></i>
          </button>

          <div 
            className="max-w-6xl w-full" 
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={appliances[selectedImage].image}
              alt={t(appliances[selectedImage].captionKey)}
              className={`w-full h-auto max-h-[85vh] object-contain ${selectedImage === 0 ? '-rotate-90' : ''} ${selectedImage === 8 ? 'rotate-90' : ''}`}
            />
            <p className="text-white text-center mt-6 text-xl md:text-2xl font-medium">
              {t(appliances[selectedImage].captionKey)}
            </p>
          </div>
        </div>
      )}
    </section>
  );
}
